// extracted by mini-css-extract-plugin
export default {"icon__wrapper":"PlayIcon_icon__wrapper__yzi5e"};